import { render, staticRenderFns } from "./BreakpointsSelector.vue?vue&type=template&id=81381250&scoped=true&"
import script from "./BreakpointsSelector.vue?vue&type=script&lang=js&"
export * from "./BreakpointsSelector.vue?vue&type=script&lang=js&"
import style0 from "./BreakpointsSelector.vue?vue&type=style&index=0&id=81381250&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81381250",
  null
  
)

export default component.exports